var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking"},[_c('ve-histogram',{attrs:{"width":"1134px","data":_vm.rankingData,"settings":_vm.settings,"extend":_vm.chartExtend,"legend-visible":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }